/**
 * Marketing tracking constants
 * All hardcoded values for tracking providers live here.
 * No environment variables - everything is in this file.
 */

export const PROD_HOSTNAME = "app.aiauditbuddy.com";

// Google Ads
export const GOOGLE_ADS_ID = "AW-17691570626";
export const GOOGLE_ADS_SEND_TO = "AW-17691570626/w61ZCN-PrbkbEMLj__NB";

// Google Ads Conversion IDs
export const GOOGLE_ADS_CONVERSION_IDS = {
  start_trial: "AW-17691570626/4eftCObi7b8bEMLj__NB",
  change_plan: "AW-17691570626/VeeUCMuJ97YbEMLj__NB",
} as const;

// LinkedIn Insight Tag
export const LINKEDIN_PARTNER_ID = "8251148";

// LinkedIn Conversion IDs
// null = not configured yet; emitter must skip LinkedIn when null
export const LINKEDIN_CONVERSION_IDS = {
  signup: null,
  start_trial: 22749108,
  cancel_plan: null,
  change_plan: 22749116,
} as const;
